module.exports = __webpack_public_path__ + "static/media/logo-w.9aa607c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-w.svg
// module id = 132
// module chunks = 0